import useResponsiveWidth from "@/elements/hooks/use-responsive-width";
import React, { ComponentType, useCallback } from "react";
import { View, FlatList } from "react-native";
import LessonHistoryItem, {
  LessonHistoryItemData,
} from "./lesson-history-item";
import LessonHistoryEmptyState from "./lesson-history-empty-state";

type LessonHistoryListProps = {
  ListHeaderComponent: ComponentType<any>;
  lessonReports: LessonHistoryItemData[];
};

function LessonHistoryList({
  ListHeaderComponent,
  lessonReports,
}: LessonHistoryListProps) {
  const responsiveWidth = useResponsiveWidth();

  const renderItem = useCallback(
    ({ item }: { item: (typeof lessonReports)[number] }) => (
      <View className="mx-5">
        <LessonHistoryItem item={item} />
      </View>
    ),
    []
  );

  const ListEmptyComponent = useCallback(() => {
    return <LessonHistoryEmptyState />;
  }, []);

  return (
    <FlatList
      data={lessonReports}
      renderItem={renderItem}
      contentContainerStyle={{ width: responsiveWidth, alignSelf: "center" }}
      ListHeaderComponent={ListHeaderComponent}
      ListEmptyComponent={ListEmptyComponent}
      ItemSeparatorComponent={() => (
        <View className="h-[1px] bg-gray-200 mx-5" />
      )}
      ListFooterComponent={() => <View className="h-[1px] bg-gray-200 mx-5" />}
    />
  );
}

export default LessonHistoryList;
